<script lang="ts">
  import ChipInput from "../input/ChipInput.svelte";
  import type { FacetValue, FacetValueOptions } from "./type.ts";
  import { MultiSelect } from "../facet-value-input";
  import { Text } from "../facet-value-label";

  interface Props extends FacetValue, FacetValueOptions {}

  let { input = checkbox, children = text, variantGray = false, ...rest }: Props = $props();
</script>

{#snippet checkbox()}
  <MultiSelect {...rest} />
{/snippet}

{#snippet text()}
  <Text size="125" {...{ ...rest, showCount: false }} />
{/snippet}

<ChipInput {input} {variantGray}>{@render children?.()}</ChipInput>
